import { AfterViewInit, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MESSAGE_TOAST } from 'src/app/shared/enums/message-toast-enum';
import { PATH_ROUTING } from 'src/app/shared/enums/routing-enums';
import { Spinner } from '../../../../../../core/services/spinner.service';
import { CustomValidator } from '../../../../../../shared/directive/custom-validator';
import { SrmService } from 'src/app/shared/service/srm.service';
export class GSLModel {
  gslNumber: string;
  supplierName: string;
  parentCompanyName: string;
  isEdit: boolean;

  constructor(gslNumber: string, supplierName: string, parentCompanyName: string, isEdit: boolean) {
    this.gslNumber = gslNumber;
    this.supplierName = supplierName;
    this.parentCompanyName = parentCompanyName;
    this.isEdit = isEdit;
  }
}

@Component({
  selector: 'app-eol-setups-form',
  templateUrl: './eol-setups-form.component.html',
  styleUrls: ['./eol-setups-form.component.scss']
})
export class EolSetupsFormComponent implements OnInit, AfterViewInit {

  isEdit = false;
  supplierForm: FormGroup;
  supplierId: string;
  isSupplierForm = true;
  isSubmit = false;

  constructor(
    private spinner: Spinner,
    private toastr: ToastrService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private srmService: SrmService,
  ) { }

  ngOnInit() {
    this.isSupplierForm = this.router.url.includes('supplier-form');
    this.activatedRoute.params.subscribe(res => {
      if (res.id) {
        this.supplierId = res.id;
        this.isEdit = true;
        this.getDataEdit(this.isSupplierForm, this.supplierId);
      }
    });
    // this.listInfo.push(new GSLModel('', '', '', true));
    this.initForm();
  }

  ngAfterViewInit() {
    this.cdr.detectChanges();
  }

  public initForm(model?: any) {
    this.supplierForm = new FormGroup({
      supplierGsl: new FormControl('', [CustomValidator.required]),
      supplierName: new FormControl('', [CustomValidator.required]),
      processingMethod: new FormControl('', [CustomValidator.required]),
      parentSupplier: new FormControl(''),
      scxId: new FormControl(''),
      srm: new FormControl(null),
      destruction: new FormControl(null, [CustomValidator.required]),
      recycling: new FormControl(null, [CustomValidator.required]),
      attribute1: new FormControl(''),
      attribute2: new FormControl(''),
      attribute3: new FormControl(''),
      attribute4: new FormControl(''),
      attribute5: new FormControl(''),
    });
    if (this.isSupplierForm) {
      this.supplierForm.get('processingMethod')?.clearValidators();
    }
    if (!this.isSupplierForm) {
      this.supplierForm.get('supplierGsl')?.clearValidators();
      this.supplierForm.get('supplierName')?.clearValidators();
      this.supplierForm.get('destruction')?.clearValidators();
      this.supplierForm.get('recycling')?.clearValidators();
    }
  }

  public submit() {
    this.isSubmit = true;
    if (this.supplierForm.invalid) {
      this.markFormGroupTouched(this.supplierForm);
      return;
    }
    const formValue = this.supplierForm.getRawValue();
    const toBool = (val: any) => val === null || val === undefined ? null : val === true || val === 'true';
    const rawRequestModel = {
      ...formValue,
      id: this.isEdit ? Number(this.supplierId) : undefined,
      srm: toBool(formValue?.srm),
      destruction: toBool(formValue?.destruction),
      recycling: toBool(formValue?.recycling),
    };
    const requestModel = Object.keys(rawRequestModel).reduce((acc, key) => {
      const value = rawRequestModel[key];
      if (value !== null && value !== undefined && value !== '') {
        acc[key] = value;
      }
      return acc;
    }, {} as any);
  
    this.spinner.show();
    if (!this.isEdit) {
      const _service = this.isSupplierForm
        ? this.srmService.createSupplierForm(requestModel)
        : this.srmService.createFiberglass(requestModel);
      _service.subscribe((res: any) => {
        this.spinner.hide();
        if (res.status === 200) {
          if (this.isSupplierForm) {
            this.toastr.success(MESSAGE_TOAST.CREATE_SUPPLIER_FORM_SUCCESS);
          } else {
            this.toastr.success(MESSAGE_TOAST.CREATE_FIBERGLASS_SUCCESS);
          }
          this.router.navigate([PATH_ROUTING.PATH_SRM, PATH_ROUTING.PATH_ADMIN, PATH_ROUTING.PATH_EOL_SETUPS]);
        }
      });
    } else {
      const _service = this.isSupplierForm
        ? this.srmService.updateSupplierForm(requestModel)
        : this.srmService.updateFiberglass(requestModel);
      _service.subscribe((res: any) => {
        this.spinner.hide();
        if (res.status === 200) {
          if (this.isSupplierForm) {
            this.toastr.success(MESSAGE_TOAST.UPDATE_SUPPLIER_FORM_SUCCESS);
          } else {
            this.toastr.success(MESSAGE_TOAST.UPDATE_FIBERGLASS_FORM_SUCCESS);
          }
          this.router.navigate([PATH_ROUTING.PATH_SRM, PATH_ROUTING.PATH_ADMIN, PATH_ROUTING.PATH_EOL_SETUPS]);
        }
      });
    }

  }

  private markFormGroupTouched(formGroup: FormGroup): void {
    (Object as any).values(formGroup.controls).forEach((control: any) => {
      control.markAsTouched();
      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }

  public getDataEdit(isSupplierForm = true, id: number | string) {
    const _service = isSupplierForm 
      ? this.srmService.getSupplierFormDetails(id)
      : this.srmService.getFiberglassDetails(id);
    this.spinner.show();
    _service.subscribe(res => {
      this.spinner.hide();
      if (res.data && res.status === 200) {
        const responseData = res.data;
        const toSelectValue = (val: any) => val === null || val === undefined ? null : String(val);
        this.supplierForm.patchValue({
          ...responseData,
          srm: toSelectValue(responseData?.srm),
          destruction: toSelectValue(responseData?.destruction),
          recycling: toSelectValue(responseData?.recycling),
        })
      }
    });
  }
}